import { IList } from '@eventr/common'
import { AxiosRequestConfig, AxiosResponse } from 'axios'
import {
    getBaseUrl,
    instance,
    instanceNoAuth,
    responseBody,
    responseBodyWithHeaders,
} from './axios'

export const requestsItinerary = {
    get: <T>(url: string, config?: AxiosRequestConfig<any>) =>
        instance
            .get<T>('itinerary/v1/' + url, config)
            .then<T>((response: AxiosResponse<any, any>) => {
                if (config?.WITH_HEADERS) {
                    return responseBodyWithHeaders<T>(response)
                }
                return responseBody<T>(response)
            }),
    post: (url: string, body: {}, config?: AxiosRequestConfig<any>) =>
        instance.post('itinerary/v1/' + url, body, config).then(responseBody),
    put: (url: string, body: {}) =>
        instance.put('itinerary/v1/' + url, body).then(responseBody),
    delete: (url: string) =>
        instance.delete('itinerary/v1/' + url).then(responseBody),
}

export const requestShareCode = {
    get: <T>(url: string) => instanceNoAuth.get<T>(url).then<T>(responseBody),
}

export const Lists = {
    fetchLists: (listType: string | string[]): Promise<IList[]> => {
        return requestsItinerary.post('lists', { listType })
    },
    fetchAllLists: (): Promise<IList[]> => {
        return requestsItinerary.get('lists/all', { NOT_IN_GUEST: true })
    },
    createOrUpdateList: (list: IList): Promise<string> => {
        return requestsItinerary.post('list/create', { list })
    },
    deleteList: (listId: string): Promise<void> => {
        return requestsItinerary.delete(`list/${listId}`)
    },
}

export const requestsEventrShared = {
    get: <T>(url: string, config?: AxiosRequestConfig<any>) =>
        instance
            .get<T>(getBaseUrl() + 'eventr/v1/' + url, config)
            .then<T | any>(responseBody),
    post: (url: string, body: {}) =>
        instance
            .post(getBaseUrl() + 'eventr/v1/' + url, body)
            .then(responseBody),
    put: (url: string, body: {}) =>
        instance
            .put(getBaseUrl() + 'eventr/v1/' + url, body)
            .then(responseBody),
    delete: (url: string) =>
        instance.delete(getBaseUrl() + 'eventr/v1/' + url).then(responseBody),
}

export const requestsEventrSharedNoAuth = {
    get: <T>(url: string, params: {}) =>
        instanceNoAuth
            .get<T>(getBaseUrl() + 'eventr/v1/' + url, params)
            .then<T | any>(responseBody),
    post: (url: string, body: {}) =>
        instanceNoAuth
            .post(getBaseUrl() + 'eventr/v1/' + url, body)
            .then(responseBody),
    put: (url: string, body: {}) =>
        instanceNoAuth
            .put(getBaseUrl() + 'eventr/v1/' + url, body)
            .then(responseBody),
    delete: (url: string) =>
        instanceNoAuth
            .delete(getBaseUrl() + 'eventr/v1/' + url)
            .then(responseBody),
}
